import type { AppRouteRecordRaw } from '/@/router/types';
import { PORTAL_LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

export const route: AppRouteRecordRaw = {
  path: '/portal',
  name: 'Portal',
  component: PORTAL_LAYOUT,
  redirect: '/portal/main',
  meta: {
    title: '首页',
    hideMenu: true,
    ignoreAuth: true,
  },
  children: [
    {
      path: 'main',
      name: 'PortalMain',
      component: () => import('/@/views/portal/main/index.vue'),
      meta: {
        title: t('routes.portal.index'),
        ignoreAuth: true,
      },
    },
    {
      path: 'result',
      name: 'PortalResult',
      component: () => import('/@/views/portal/result/index.vue'),
      meta: {
        title: t('routes.portal.result'),
        ignoreAuth: true,
      },
    },
    {
      path: 'incorrupt',
      name: 'PortalIncorrupt',
      component: () => import('/@/views/portal/incorrupt/index.vue'),
      meta: {
        title: t('routes.portal.incorrupt'),
        ignoreAuth: true,
      },
    },
    {
      path: 'register',
      name: 'Register',
      component: () => import('/@/views/portal/register/index.vue'),
      meta: {
        title: t('routes.portal.register'),
      },
    },
    {
      path: 'register-email',
      name: 'RegisterEmail',
      component: () => import('/@/views/portal/register-email/index.vue'),
      meta: {
        title: t('routes.portal.register'),
      },
    },
    {
      path: 'company-type',
      name: 'CompanyType',
      component: () => import('/@/views/portal/company-type/index.vue'),
      meta: {
        title: t('routes.portal.company-type'),
      },
    },
    {
      path: 'authenticate',
      name: 'Authenticate',
      component: () => import('/@/views/portal/authenticate/index.vue'),
      meta: {
        title: t('routes.portal.authenticate'),
      },
    },
    {
      path: 'list',
      name: 'List',
      component: () => import('/@/views/portal/list/index.vue'),
      meta: {
        title: t('routes.portal.list'),
      },
    },
    {
      path: 'detail',
      name: 'Detail',
      component: () => import('/@/views/portal/detail/index.vue'),
      meta: {
        title: t('routes.portal.detail'),
      },
    },
    {
      path: 'person-center',
      name: 'PersonCenter',
      component: () => import('/@/views/portal/person-center/index.vue'),
      meta: {
        title: t('routes.portal.person-center'),
      },
    },
    {
      path: 'protocol',
      name: 'Protocol',
      component: () => import('/@/views/portal/protocol/index.vue'),
      meta: {
        title: t('routes.portal.protocol'),
      },
    },
    {
      path: 'helper',
      name: 'PortalHelper',
      component: () => import('/@/views/portal/helper/index.vue'),
      meta: {
        title: t('routes.portal.helper'),
        ignoreAuth: true,
      },
    },
    {
      path: 'blacklist',
      name: 'PortalBlacklist',
      component: () => import('/@/views/portal/Blacklist/index.vue'),
      meta: {
        title: t('routes.portal.blacklist'),
        ignoreAuth: true,
      },
    },
  ],
};

export default { route };
